import React from 'react';
import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { useLocaleContext } from '../../context/LocaleContext';
import ModalCustom from '../../design/shared/modal';
import { ModalBox } from '../css';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import TypeAhead from './typeAhead';

const DefectAssignee = ({
  selectedAssignee,
  adminUsers,
  onAssigneeChange,
  onClickSave,
  setAssigneeModal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const local = useLocaleContext();
  const {
    ORDERS: { unassigned, assigneModelHeader },
  } = localizedStrings;
  const { DEFECT_MANAGEMENT: { ADD_BUTTON, ASSIGNEE_HEADER } = {} } = local === 'en-US' ? EN : FR;
  const closeModal = () => setAssigneeModal(false);
  const onClick = () => {
    onClickSave(false);
    closeModal();
  };

  return (
    <ModalCustom
      open="true"
      setOpen={closeModal}
      header={ASSIGNEE_HEADER}
      customStyles={{ height: '450px' }}
    >
      <TypeAhead
        label={'Choose Assignee from the list'}
        onChange={onAssigneeChange}
        options={adminUsers}
        selected={selectedAssignee}
        placeholder={unassigned}
      />
      <ModalBox>
        <Button onClick={onClick}>{ADD_BUTTON}</Button>
      </ModalBox>
    </ModalCustom>
  );
};

DefectAssignee.propTypes = {
  setAssigneeModal: PropTypes.func.isRequired,
  onAssigneeChange: PropTypes.func.isRequired,
  onClickSave: PropTypes.func.isRequired,
  assignee: PropTypes.arrayOf(PropTypes.string).isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ).isRequired
};

export default DefectAssignee;
